import * as React from 'react';
import DefaultLink from "@insolus/ui-kit/components/Link";
import DefaultButton from "@insolus/ui-kit/components/Button";
export var DEFAULT_CONFIG = {
  compact: undefined,
  baseComponents: {
    Link: DefaultLink,
    Button: DefaultButton
  }
};
export default React.createContext(DEFAULT_CONFIG);